import React from 'react';
import { FormattedMessage } from 'react-intl';

export default () => (
    <div className="notification is-danger">
        <FormattedMessage id="contactForm.errorMessage" />
    </div>
);



// WEBPACK FOOTER //
// ./src/components/ConferenctProgramForm/components/ErrorNotification.js